declare global {
    interface Window { 
        vc3dAPI:IVc3dAPI; 
    }
}

export interface IVc3dAPI {
    webGlAvailable:boolean,
    changeProduct?:(productId:string) => void,
    getActiveProduct?:() => string,
    fitToContainer?:() => void,
}


export interface Product {
    name:string,
    scene:string
}

export enum IUserAgentType {
    desktop,
    mobile
}

export interface ICanvasSize {
    w:number,
    h:number
}